import type { CSSProperties, ReactElement } from 'react';
import { CIBLE_MIN, COULEURS, POLICE_SYSTEME } from '../../app/styles.js';
import type { EtatClient } from './controleur.js';

/** Portail client : police système, 18 px au minimum (UX-22). */
const styleRacine: CSSProperties = { fontFamily: POLICE_SYSTEME, fontSize: 18, lineHeight: 1.5, color: COULEURS.marineFonce };
const styleLien: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  minHeight: CIBLE_MIN,
  padding: '0 16px',
  borderRadius: 8,
  border: `1px solid ${COULEURS.marine}`,
  color: COULEURS.marine,
  fontSize: 18,
  textDecoration: 'none',
};

/**
 * M06 · Régler ma quote-part. La vue ne reçoit que le reste dû et la prochaine échéance (ou « Vous êtes à jour ») :
 * aucune somme déjà réglée, aucun nom, aucune estimation.
 */
export function PaiementClient({ etat }: { etat: EtatClient }): ReactElement {
  const entete = <h1 style={{ color: COULEURS.marine, fontSize: 28 }}>Régler ma quote-part</h1>;
  const { vue } = etat;
  return (
    <section data-composant="paiement-client" style={styleRacine}>
      {entete}
      {etat.statut === 'chargement' ? <p role="status">Chargement de votre situation en cours…</p> : null}
      {etat.statut === 'erreur' && etat.message ? <p role="alert">{etat.message}</p> : null}
      {etat.statut === 'pret' && vue ? (
        <>
          <h2 style={{ fontSize: 24 }}>{vue.titre}</h2>
          {vue.prochaine ? <p>Prochaine échéance : {vue.prochaine}</p> : null}
          {!vue.aJour ? (
            <p>
              Pour régler, utilisez le lien de paiement sécurisé que le Cabinet MAAT vous a envoyé. Une difficulté pour payer ? Signalez-la
              au Cabinet MAAT : une solution peut être trouvée.
            </p>
          ) : null}
          {vue.recus ? (
            <p>
              <a href={vue.recus} style={styleLien}>
                Voir mes reçus
              </a>
            </p>
          ) : null}
          <p>Cabinet MAAT</p>
        </>
      ) : null}
    </section>
  );
}
